export enum CONTACT_LINK_TYPE {
  Email = 'email',
  Phone = 'phone',
}
